import { render, staticRenderFns } from "./4mImprRiskReduceDetail.vue?vue&type=template&id=662be2e4"
import script from "./4mImprRiskReduceDetail.vue?vue&type=script&lang=js"
export * from "./4mImprRiskReduceDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('662be2e4')) {
      api.createRecord('662be2e4', component.options)
    } else {
      api.reload('662be2e4', component.options)
    }
    module.hot.accept("./4mImprRiskReduceDetail.vue?vue&type=template&id=662be2e4", function () {
      api.rerender('662be2e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/4m/risk/4mImprRiskReduceDetail.vue"
export default component.exports